import { render, staticRenderFns } from "./DetalleActividad.vue?vue&type=template&id=8438b822&scoped=true&"
import script from "./DetalleActividad.vue?vue&type=script&lang=js&"
export * from "./DetalleActividad.vue?vue&type=script&lang=js&"
import style0 from "./DetalleActividad.vue?vue&type=style&index=0&id=8438b822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8438b822",
  null
  
)

export default component.exports